import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert, Modal} from 'react-bootstrap';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';

import ReportSekolahStaEntity from '../../../../../entity/ReportSekolahStaEntity';

import './sta.css';

import RenderChartSatuan from '../dinas/components/RenderChartSatuan';

import { Typography, Grid } from '@material-ui/core';



class ReportSekolahSta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportSekolahStaEntity: ReportSekolahStaEntity,
            isFetching: false
        }
    }


    async componentDidMount(){
        console.info('ReportSekolahSta - PROPS', this.props.location.state.data)
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        this.fetchReportSekolahSta();
    }


    render() { 
        const {reportSekolahStaEntity, isFetching} = this.state;
        return (
            <div className="pageSta">
            <LoaderModal isFetching={isFetching} />
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={5}
                >

                <Grid item container spacing={2}>
                    {/* HEADER */}
                    <Grid item xs={12}>
                        <img src="/image/sta/header-sta-sekolah.png" width="100%"/>
                    </Grid>

                    <Grid item xs={12} sm={12} >
                        <div className="main-bg-color text-header" >persentase kecenderungan potensi siswa</div>
                    </Grid>

                    <Grid item xs={3} align="center" >
                        <img src="/image/sta/topi-wisuda-sta.png" width="70%"/><br /><br />
                        <b className="text-nama-sekolah">{this.props.account.namaUser}</b>
                    </Grid>

                    <Grid item xs={3} style={{marginTop: 20}}>
                            <RenderChartSatuan value={reportSekolahStaEntity.prosentaseProfesional} color={'#56CCF2'}/>
                            <div className="text-tengah-grafik">
                                <i className="text-prosentase">{reportSekolahStaEntity.prosentaseProfesional} %</i>
                                <Typography variant="body2" color="initial">{reportSekolahStaEntity.totalProfesional} siswa</Typography>
                            </div>
                    </Grid>

                    <Grid item xs={3} style={{marginTop: 20}}>
                            <RenderChartSatuan value={reportSekolahStaEntity.prosentaseEnterpreanuer} color={'#6FCF97'}/>
                            <div className="text-tengah-grafik">
                                <i className="text-prosentase">{reportSekolahStaEntity.prosentaseEnterpreanuer} %</i>
                                <Typography variant="body2" color="initial">{reportSekolahStaEntity.totalEnterpreanuer} siswa</Typography>
                            </div>
                    </Grid>

                    <Grid item xs={3} style={{marginTop: 20}}>
                            <RenderChartSatuan value={reportSekolahStaEntity.prosentaseNextStudy} color={'#F4A442'}/>
                            <div className="text-tengah-grafik">
                                <i className="text-prosentase">{reportSekolahStaEntity.prosentaseNextStudy} %</i>
                                <Typography variant="body2" color="initial">{reportSekolahStaEntity.totalNextStudy} siswa</Typography>
                            </div>
                    </Grid>               

                </Grid>

                <Grid item container>
                </Grid>

                <Grid item container >
                    <Grid item xs={12}>
                        <div className="main-bg-color text-header" >daftar kecenderungan potensi siswa</div>
                    </Grid>

                    <Grid item >
                        &nbsp;
                    </Grid>

                    <Grid item xs={12}>
                        <table width="100%">
                            <tr className="main-bg-color text-table">
                                <td className="text-center" width="7%">No</td>
                                <td width="43%">Nama Siswa</td>
                                <td className="text-center">Profesional</td>
                                <td className="text-center">Entrepreneur</td>
                                <td className="text-center">Lanjut Study</td>
                            </tr>
                            {
                                !__.isEmpty(reportSekolahStaEntity) &&
                                    reportSekolahStaEntity.siswa.map((val, i)=>
                                        <tr style={{borderBottom: 'inset', height: '3em'}}>
                                            <td className="text-center">{i+1}</td>
                                            <td width="43%">{val.siswa}</td>
                                            <td className="text-center">
                                                {
                                                    val.isProfesional ? <img alt="loading" src="/image/sta/centang-pro.svg" /> : <img alt="loading" src="/image/sta/strep.svg" />
                                                }
                                            </td>
                                            <td className="text-center">
                                                {
                                                    val.isEnterpreanuer ? <img alt="loading" src="/image/sta/centang-enter.svg" /> : <img alt="loading" src="/image/sta/strep.svg" />
                                                }
                                            </td>
                                            <td className="text-center">
                                                {
                                                    val.isNextStudy ? <img alt="loading" src="/image/sta/centang-next-study.svg" /> : <img alt="loading" src="/image/sta/strep.svg" />
                                                }
                                            </td>
                                        </tr>
                                    )

                            }
                            
                        </table>
                    </Grid>
                </Grid>

            </Grid>


                <div id="btn_print">                        
                    <div className="fixed_button">
                        <button className="btn btn-outline-primary  pull-right" title="Print Report" style={{marginRight:'1em'}} onClick={() => window.print()}>
                            <li className="fa fa-print"></li>
                        </button>
                    </div>     
                </div> 

            </div>
        );
    }

    fetchReportSekolahSta = async () =>{
        this.setState({ isFetching: true });
        const {idProfilCbt, idJadwal, idKelas, kodeTa} = this.props.location.state.data;
        const response = await accountManagement.get(CONFIG.REPORT_CBT_STA_SEKOLAH,
            {params : 
                {
                    idProfilCbt: idProfilCbt,
                    idJadwalCbt: idJadwal,
                    idKelas: idKelas,
                    tahunAjaran: kodeTa

                }
            }
        ).catch(function(error){

        })

        console.info('response.data.errorSchema.errorCode', response.data.errorSchema.errorCode);
        console.info('response.data.data', response.data.data);

        if(response)
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ reportSekolahStaEntity: response.data.data });
            }

        this.setState({ isFetching: false });
    }


}
 
 
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ReportSekolahSta);